const ITEMS = [
    "Signature facials",
    "Medical peels",
    "Skin needling",
    "Dermaplaning",
    "Targeted acne care",
    "Brow & waxing",
];

const Asterisk = () => (
    <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        className="shrink-0 text-clay"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
    >
        <path d="M12 2v20M2 12h20M4.9 4.9l14.2 14.2M19.1 4.9L4.9 19.1" />
    </svg>
);

function Row({ hidden = false }) {
    return (
        <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
            {ITEMS.map((t, i) => (
                <span key={i} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-serif text-lg font-light uppercase tracking-[0.28em] text-earth md:px-10 md:text-2xl">
                        {t}
                    </span>
                    <Asterisk />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div
            data-testid="editorial-marquee"
            className="overflow-hidden border-y border-ink/10 bg-linen py-6 md:py-7"
        >
            <div className="marquee-track">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
